import { apiObjUrl } from "src/common/apiUrl";
import { rest } from "src/common/rest";
import { ZUid } from "src/types/zUid";
import {
  EntityFilterItem,
  ZEntityFilterValue,
  zEntityFilterValue,
} from "./types";

export const loadTreeAttrValues = async (
  objectId: ZUid,
  filters: EntityFilterItem[],
): Promise<ZEntityFilterValue[]> => {
  const resp = await rest.post<ZEntityFilterValue[]>(
    apiObjUrl("/v2/values/search"),
    {
      objectId,
      filters,
    },
    { translate: true },
  );
  return zEntityFilterValue.array().parse(resp.data);
};
